import * as React from 'react';
import { ToggleButtonProps, ToggleButton } from '@material-ui/lab';

export type DSToggleButtonProps = ToggleButtonProps;

export const DSToggleButton: React.FC<DSToggleButtonProps> = props => <ToggleButton {...props} />;
DSToggleButton.displayName = 'DSToggleButton';
